import { useQuery } from '@tanstack/react-query';

import { Evidence } from '@app/domain-evidence-interfaces';
import { Axios } from '@app/web-components';

const EVIDENCE_ALL_QUERY_KEY = 'EVIDENCE_ALL_QUERY_KEY';

const evidenceKeys = {
  all: [EVIDENCE_ALL_QUERY_KEY] as const,
  lists: () => [...evidenceKeys.all, 'list'] as const,
  list: (filters: object) => [...evidenceKeys.lists(), filters] as const,
};

export const useFindEvidenceByEnterpriseId = (enterpriseId: string, enabled: boolean) => {
  const axios = Axios.useAxiosApi();

  return useQuery<Evidence>({
    queryKey: evidenceKeys.list({ enterpriseId }),
    queryFn: async () => {
      const { data } = await axios.get(`/evidence/${enterpriseId}`);
      return data;
    },
    enabled,
  });
};
